import { useEffect, useState } from 'react';

export const usePageVisibility = () => {
  const initiallyVisible = !document.hidden;

  const [isVisible, setIsVisible] = useState(initiallyVisible);

  useEffect(() => {
    const handler = () => setIsVisible(!document.hidden);
    document.addEventListener('visibilitychange', handler);
    return () => {
      document.removeEventListener('visibilitychange', handler);
    };
  }, []);

  return isVisible;
};
